import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import FloatingButtons from './Components/FloatingButtons';
import DistrictPage from './Pages/DistrictPage';
import Homepage from './Pages/HomePage';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/:slug" element={<DistrictPage />} />
      </Routes>
      <Footer />
      <FloatingButtons />
    </Router>
  );
}

export default App;